import { arrType, datatypes, inputTypes } from "data/globalData";

const selectOptions = {
	type: arrType,
	list: [{ name: "Loading...", key: "Loading" }],
};

export const filterColArry = [
	{
		name: "Facility",
		key: "display_name",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
	{
		name: "Brand",
		key: "brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
	// {
	// 	name: "Section",
	// 	key: "SECTION",
	// 	input_type: inputTypes.MULTIPLE_SELECT.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 3,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// 	select_options: { ...selectOptions },
	// },
	{
		name: "Season",
		key: "SEASON",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 4,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
	{
		name: "Sub Brand",
		key: "SUB_BRAND",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 5,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
	{
		name: "Division",
		key: "division",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 5,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
	{
		name: "Department",
		key: "DEPARTMENT",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 5,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: { ...selectOptions },
	},
];
